import { render, staticRenderFns } from "./SskAktifDetay.vue?vue&type=template&id=65a6796c"
import script from "./SskAktifDetay.vue?vue&type=script&lang=ts"
export * from "./SskAktifDetay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports